﻿import global from '../globals';
import creator from '../elementCreator';

"use strict";
var privateFns, clickFns, intranett;
var urlBase = {partList: {}, addPart: {}};
privateFns = {
	sharePage: function(){
		var el = creator.createDiv({id: "share-page", css: "drop_downs"});
		el.setAttribute("data-enhance", "false");
		var userMessage1 = creator.createDiv({css: "user-message-intranett", text: "OBS: Intranettversjonen fungerer bare internt i kommunen"});
		el.appendChild(userMessage1);
		let shareControls = creator.createDiv({id: "share-controls", css: "drop_downs"});
		let pointCheckBox = creator.createInput({type: "checkbox", id: "pointNoMark", group: "point", name: "Punkt"});
		pointCheckBox.checked = true;
		shareControls.appendChild(pointCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointNoMark", text: "Punkt"}));
		shareControls.appendChild(creator.createBr({}));
		let pointMarkCheckBox = creator.createInput({type: "checkbox", id: "pointMark", group: "point", name: "Punkt markert"});
		shareControls.appendChild(pointMarkCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "pointMark", text: "Punkt markert"}));
		shareControls.appendChild(creator.createBr({}));
		let minCheckBox = creator.createInput({type: "checkbox", id: "min", group: "min", name: "Min"});
		shareControls.appendChild(minCheckBox);
		shareControls.appendChild(creator.createLabel({labelfor: "min", text: "Minimer"}));
		shareControls.appendChild(creator.createBr({}));
		let modeCheckBox = creator.createInput({type: "checkbox", id: "mode", group: "mode", name: "Mode"});
		minCheckBox.checked = true; 
		
		el.appendChild(shareControls);
		el.appendChild(creator.createDiv({id: "shareUrl", css: "share-url"}));
		var userMessage2 = creator.createDiv({css: "user-message-intranett", text: "Lenken over åpner i et nytt vindu. Der kan du lagre bokmerke eller snarveg til det du ser på skjermen nå."});
		el.appendChild(userMessage2);
		var span = creator.createSpan({text: "Del via: "});
		el.appendChild(span);
		
		pointCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.point = "&north=" + global.map.getView().getCenter()[1]  + "&east=" + global.map.getView().getCenter()[0]; 
			urlBase.addPart.point = e.target.checked;
			if(e.target.checked){
				urlBase.addPart.pointMark = !e.target.checked;
				pointMarkCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		pointMarkCheckBox.onclick = function(e){
			//var urlBase = {partList: {}, addPart: {}};
			urlBase.partList.pointMark = "&lat=" + global.map.getView().getCenter()[1]  + "&lon=" + global.map.getView().getCenter()[0]; 
			urlBase.addPart.pointMark = e.target.checked;
			if(e.target.checked){					
				urlBase.addPart.point = !e.target.checked;
				pointCheckBox.checked = !e.target.checked;
			}
			privateFns.updateUrl();
		};
		minCheckBox.onclick = function(e){
			urlBase.partList.min = "&min=true"; 
			urlBase.addPart.min = e.target.checked;
			privateFns.updateUrl();
		};
		modeCheckBox.onclick = function(e){
			urlBase.addPart.mode = e.target.checked;
			privateFns.updateUrl();
		};
		
		var container = creator.createDiv({css: "share-btn-ct"});
		container.appendChild(creator.createA({id: "share-email", title: "Del via epost", href: "mailto:?subject=planinnsyn.oslo.no&amp;body=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "icon-Epost"}), ariaLabel: "Del lenke til planinnsyn via epost"}));
		container.appendChild(creator.createA({id: "share-twitter", title: "Del via twitter", href: "http://twitter.com/share?url=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-twitter"}), ariaLabel: "Del lenke til planinnsyn via twitter"}));
		container.appendChild(creator.createA({id: "share-facebook", title: "Del via facebook", href: "http://facebook.com/sharer.php?u=http%3A%2F%2Flocalhost%2Fws.repository%2Fkartinnsyn.v4%2Fsrc%2F%23598717%2C6643751%2C7%2C1%2C1", content: creator.createIcon({css: "fa fa-facebook"}), ariaLabel: "Del lenke til planinnsyn via facebook"}));
		
		var copyButton = creator.createButton({id: "copy-link", text: "Kopier lenke"});
		copyButton.onclick = function(){
			var doc = document, text = doc.getElementsByClassName("permalink")[0];
			var range, select = true;
			if (doc.body.createTextRange) {
				range = doc.body.createTextRange();
				range.moveToElementText(text);
				range.select();
			} else if (window.getSelection) {
				var selection = window.getSelection();
				range = doc.createRange();
				range.selectNodeContents(text);
				selection.removeAllRanges();
				selection.addRange(range);
			} else {
				console.log("tekst selektering støttes ikke");
				select = false;
			}
			if (select) {
				if (doc.execCommand("copy")) {
					alert("Lenken er kopiert");
				} else {
					alert("Nettleseren din støtter ikke automatisk kopiering. Kopier lenken manuelt.");
				}
			}
		};
		container.appendChild(copyButton);
		el.appendChild(container);
		var closeButton = creator.createButton({css: "close-me hide-me", ariaLabel: "Lukk delemeny", text: "Lukk"});
		closeButton.onclick = function(){
			$("#share-page").hide(250);
		};
		el.appendChild(closeButton);
		return el;
	},
	helpMenu: function() {
		var el = creator.createDiv({id: "help-page", css: "drop-downs floating-win"});
		el.setAttribute("data-enhance", "false");
		
		var header = creator.createHeader({});
		var btn = creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul tips"});
		btn.appendChild(creator.createIcon({css: "icon-Close"}));
		btn.onclick = function(){
			$("#help-page").hide();
			$("#planinnsyn-hjelp").toggleClass("drop-down-row-active");
			$("#planinnsyn-hjelp").find("i").toggleClass("icon-Menu").toggleClass("icon-Close");
		};
		header.appendChild(btn);
		el.appendChild(header);
		
		var content = creator.createDiv({css: "content"});
		//<!-- Article -->
		var article = creator.createDiv({});
		var articleArticle = creator.createArticle({});
		articleArticle.appendChild(creator.createParagraph({text: "Plan- og bygningsetaten ønsker å levere data av høy kvalitet, men kan ikke garantere at innholdet i tjenesten er uten feil og mangler."}));
		articleArticle.appendChild(creator.createParagraph({text: "Et reguleringsplankart er en sammenstilling av alle planforslag og gjeldende reguleringsplaner, og sammenstillingen er ikke juridisk bindende."}));
		articleArticle.appendChild(creator.createParagraph({text: "Kart og eiendomsinformasjon er beskyttet etter åndsverkloven.</strong>"}));
		article.appendChild(articleArticle);
		content.appendChild(article);
		//<!-- Tips -->
		var tips = creator.createDiv({id: "help-topic-tips", css: "help-topic"});
		var tipsButton = creator.createButton({text: "Tips", css:"btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul tips"});
		tipsButton.onclick = function(){
			if($("#tipsarticle").is(":visible")) {
				$("#tipsarticle").hide(250);
				$("#help-topic-tips").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#tipsarticle").show(200);
				$("#help-topic-tips").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		tipsButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		tips.appendChild(tipsButton);
		var tipsarticle = creator.createArticle({id: "tipsarticle"});
		tipsarticle.appendChild(creator.createParagraph({text: "<strong>Klikk i kartet for å se detaljert informasjon om eiendommen</strong>"}));
		tipsarticle.appendChild(creator.createParagraph({text: "Ved å klikke i kartet finner du blant annet gårds- og bruksnummer og planer som gjelder for eiendommen eller punktet du klikket i."}));
		tipsarticle.appendChild(creator.createParagraph({text: "<strong>Du kan finne bestemmelsene til en plan i Planinnsyn</strong>"}));
		tipsarticle.appendChild(creator.createParagraph({text: "Klikk i kartet, velg «Reguleringsplaner» og klikk på «Reguleringsbestemmelser»."}));
		tipsarticle.appendChild(creator.createParagraph({text: "<strong>Du kan finne data om planene i Planinnsyn</strong>"}));
		tipsarticle.appendChild(creator.createParagraph({text: "Klikk i kartet, velg «Kommunedelplan», «Områderegulering» eller «Reguleringsplaner» og klikk på plannummeret. For kommuneplan, må du velge «Mer info om kommuneplanen»."}));
		tipsarticle.appendChild(creator.createParagraph({text: "<strong>Finn tegnforklaringer til kartet</strong>"}));
		tipsarticle.appendChild(creator.createParagraph({text: "De fleste kart har tegnforklaringer under «Mer info» -knappen i menyen til venstre. Noen kartlag har også tegnforklaring i menyen som dukker opp når du klikker i kartet eller søker på en adresse eller eiendom."}));
		if(Object.keys(global.modes).length > 0){
			tipsarticle.appendChild(creator.createParagraph({text: "<strong>Du kan bruke mode i URL for å starte planinnsyn med enkelte kartlag slått på</strong>"}));
			tipsarticle.appendChild(creator.createParagraph({text: "Ved å bruke mode='modus' i urlen kan du starte planinnsyn med gitte kartlag skrudd på."}));
			tipsarticle.appendChild(creator.createParagraph({text: "Eks: https://od2.pbe.oslo.kommune.no/kart/?mode=gulliste"}));
			tipsarticle.appendChild(creator.createParagraph({text: "Gyldige moduser er:"}));
			var baseHref = window.location.href.split("#")[0].split("?")[0];
			tipsarticle.appendChild( creator.createUl({listItems: Object.keys(global.modes).filter(mode => typeof global.modes[mode][0] !== 'function').map(mode => '<a href=' + baseHref + '?mode=' + mode +'>' + mode + '</a>')}));
		}
		tips.appendChild(tipsarticle);
		content.appendChild(tips);
		
		//<!-- Informasjon i kartet -->
		var kartinfo = creator.createDiv({id: "help-topic-kartinfo", css: "help-topic"});
		var infoButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hva som finnes i kartet", text: "Informasjon i kartet"});
		infoButton.onclick = function(){
			if($("#infoArticle").is(":visible")) {
				$("#infoArticle").hide(250);
				$("#help-topic-kartinfo").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#infoArticle").show(200);
				$("#help-topic-kartinfo").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		infoButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		kartinfo.appendChild(infoButton);
		var infoarticle = creator.createArticle({id: "infoArticle"});
		infoarticle.appendChild(creator.createH4({text: "Klikk i kartet"}));
		infoarticle.appendChild(creator.createParagraph({text: 'Du kan få informasjon om utvalgte kartobjekter ved å klikke i kartet. Når du klikker et sted i kartet vil du få opp en meny på høyre side med informasjon om hvilke planer som gjelder for eiendommen du har klikket på, samt en rekke temaer. Dersom du har fått treff for et tema vil antall treff vises i parentes bak temaet. Dersom du ikke har fått treff vil temaet være grået ut. Det er to faner i menyen, én for eiendommen og én for punktet du klikket på.'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Hvis du klikker i menyen på høyre side får du mer informasjon om treffene, og du får lenker til mer informasjon.'}));
		infoarticle.appendChild(creator.createParagraph({text: 'For kommuneplan, kommunedelplan, områderegulering, reguleringsplaner og Gul liste kan du sette markøren på et formål og få det markert i kartet. Dette vil ikke virke for berøringsskjermer.'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Under <span>Plankunngjøringer</span> kan du se planforslag som berører eiendommen der du klikket og som enten er til offentlig ettersyn, skal vedtas eller som er i ferd med å starte opp. Klikk på tittelen for å komme til en side der du kan si din mening.'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Under <span>Byggesaker</span> får du informasjon byggesaker som er registrert på eiendommen der du klikket. Det er kun de tre ferskeste sakene som vises. For å se alle, klikk på «Vis alle byggesaker».'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Under <span>Plansaker</span> får du informasjon plansaker som er registrert på eiendommen der du klikket. Det er kun de tre ferskeste sakene som vises. For å se alle, klikk på «Vis alle plansaker».'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Under <span>Gul liste</span> kan du se om det er bygninger eller områder som er oppført på Byantikvarens gule liste der du klikket. Klikk på de enkelte treffene for å se mer om hva som er registrert og for lenke videre til Kulturminnesøk.'}));
		infoarticle.appendChild(creator.createParagraph({text: 'Nederst i menyen finner du dyplenker til produktene reguleringskart, digitale kartdata og meglerpakke i Bestillingstjenesten. Du finner også en lenke til siden "Skal du bygge, rive eller endre?" på Oslo kommunes nettsider.', css: "user-message-internett"}));
		infoarticle.appendChild(creator.createParagraph({text: 'Nederst i menyen finner du dyplenker til tjeneste for å lage reguleringsplott og til tjenesten Hva gjelder for eiendommen.', css: "user-message-intranett"}));
		kartinfo.appendChild(infoarticle);
		content.appendChild(kartinfo);
		
		//<!-- Reguleringsbestemmelser -->
		var regbestinfo = creator.createDiv({id: "help-topic-regbest", css: "help-topic"});
		var regbestButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om reguleringsbestemmelser", text: "Reguleringsbestemmelser"});
		regbestButton.onclick = function (){
			if($("#regbestArticle").is(":visible")) {
				$("#regbestArticle").hide(250);
				$("#help-topic-regbest").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#regbestArticle").show(200);
				$("#help-topic-regbest").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		regbestButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		regbestinfo.appendChild(regbestButton);
		var regbestArticle = creator.createArticle({id: "regbestArticle"});
		regbestArticle.appendChild(creator.createH4({text: "Hvordan finne reguleringsbestemmelser?"}));
		regbestArticle.appendChild(creator.createParagraph({text: "For å finne reguleringsbestemmelsen til en plan klikker du i kartet og velger Reguleringsplaner. Klikk på «Reguleringsbestemmelser». Du kan også søke på plannummeret for å få opp planen."}));
		regbestinfo.appendChild(regbestArticle);
		
		content.appendChild(regbestinfo);
		
		//<!-- Søk -->
		var sok = creator.createDiv({id: "help-topic-sok", css: "help-topic"});
		var sokButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan du søker", text: "Søk"});
		sokButton.onclick = function () {
			if($("#sokArticle").is(":visible")) {
				$("#sokArticle").hide(250);
				$("#help-topic-sok").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#sokArticle").show(200);
				$("#help-topic-sok").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		sokButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		sok.appendChild(sokButton);
		var sokArticle = creator.createArticle({id: "sokArticle"});
		sokArticle.appendChild(creator.createH4({text: "Hvordan søke?"}));
		sokArticle.appendChild(creator.createParagraph({text: "I søkefeltet kan du søke på adresser, stedsnavn, gårds- og bruksnummer, koordinat, plannavn eller saksnummer."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Adresse:</strong> For å søke på en adresse, start med å skrive inn gatenavn i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. Velg fra listen og du får opp et vindu med adresser for den valgte gaten."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Stedsnavn:</strong> For å søke på et stedsnavn, start med å skrive i søkefeltet. Etter at du har skrevet minst tre bokstaver vil du få opp forslag på gatenavn eller stedsnavn som passer med det du har skrevet inn. På høyre side i listen ser du om forslaget er en gate eller et stedsnavn. Velg fra listen for å gå til stedet du ønsker."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Eiendom:</strong> For å søke på en eiendom, skriv på formen gnr/bnr.<br>Eksempel: <span>101/1</span>."}));
		sokArticle.appendChild(creator.createParagraph({text: '<strong>Koordinat:</strong> For å søke på koordinat skriv inn nord-koordinat og øst-koordinat adskilt med tegnet "|" (tasten til venstre for "1"). Søket fungerer også om du snur om på rekkefølgen på koordinatene.<br>Eksempel: <em>6643409|598546</em>'}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Plannavn:</strong> For å søke på en reguleringsplan skriver du inn plannavnet.<br>Eksempel: <span>S-3478</span>. Etter at du har skrevet inn minst tre tegn vil du få opp forslag på planer som passer med det du har skrevet inn. Velg plan fra listen."}));
		sokArticle.appendChild(creator.createParagraph({text: "<strong>Saksnummer:</strong> For å søke på en sak (byggesak/plansak) skriv inn saksnummeret i søkefeltet.<br>Eksempel: <em>201600477</em>."}));
		sok.appendChild(sokArticle);
		
		content.appendChild(sok);
		
		// <!-- Hvordan bruke verktøy -->
		var tools = creator.createDiv({id: "help-topic-tools", css: "help-topic"});
		var toolsButton =  creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om hvordan du bruker verktøy", id: "tool-info-btn", text: "Hvordan bruke verktøy"});
		toolsButton.onclick = function(){
			if($("#toolArticle").is(":visible")) {
				$("#toolArticle").hide(250);
				$("#help-topic-tools").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#toolArticle").show(200);
				$("#help-topic-tools").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		toolsButton.appendChild(creator.createIcon({css:"icon-Chevron-down tipsmenu-expander"}));
		tools.appendChild(toolsButton);
		var toolArticle = creator.createArticle({id: "toolArticle"});
		toolArticle.appendChild(creator.createH4({text: "Hvordan bruke verktøy?"}));
		var row  = creator.createDiv({css: "help-topic-tool-row"});
		var img  = creator.createDiv({css: "help-topic-tool-img", text: '<span class = "icon-Minus-sign"></span>'});
		var desc = creator.createDiv({css: "help-topic-tool-desc", text: "Zoom ut et nivå"});
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class = "icon-Plus-sign"></span>';
		desc.innerHTML = "Zoom inn et nivå";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = "<span>m²</span>";
		desc.innerHTML = "Mål areal. Klikk i kartet til det blå omrisset dekker arealet du ønsker å måle. Dobbeltklikk for å avslutte. Hold inne shift for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
				
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class= "icon-measure"></span>';
		desc.innerHTML = "Mål avstand. Klikk i punktet du ønsker å måle fra, klikk deretter for å legge inn knekkpunkter eller dobbeltklikk for å avslutte måling. Hold inne 'shift' for å måle på frihånd. Slå av verktøyet ved å klikke på knappen igjen.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		
		img.innerHTML = '<span class= "fa fa-pencil"></span>';
		desc.innerHTML = "Tegn i kartet. Klikk i kartet for å starte tegning. Klikk et annet sted i kartet for å lage en linje. Dobbelklikk for å avslutte tegning. Hold inne shift for å tegne frihånd. Bruk redigeringsknappen for å flytte linjer.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
				
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		img.innerHTML = "";
		
		img.innerHTML = '<span class= "glyphicon glyphicon-globe"></span>';
		desc.innerHTML = "Zoomer til hele kartet";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		
		row = row.cloneNode(true);
		row.innerHTML = "";
		img = img.cloneNode(true);
		desc = desc.cloneNode(true);
		img.innerHTML = "";
		
		img.innerHTML = '<span class= "glyphicon glyphicon-erase"></span>';
		desc.innerHTML = "Fjern tegninger, målinger og markering av eiendom og planer.";
		row.appendChild(img);
		row.appendChild(desc);
		toolArticle.appendChild(row);
		for(var plug in global.registeredPlugins){
			var current = global.registeredPlugins[plug];
			if(current.userGuide){
				row = row.cloneNode(true);
				row.innerHTML = "";
				row.id = "tool-info-" + current.id;
				img = img.cloneNode(true);
				desc = desc.cloneNode(true);
				img.innerHTML = "";
				
				if(current.userGuide.img.type === "icon"){
					img.innerHTML = '<span class= "' + current.userGuide.img.className + '"></span>';
				}
				desc.innerHTML = current.userGuide.text;
				row.appendChild(img);
				row.appendChild(desc);
				row.className += current.userGuide.className ? " " +current.userGuide.className : "";
				toolArticle.appendChild(row);
			}
		}
		
		tools.appendChild(toolArticle);
		content.appendChild(tools);
		
		//<!-- Løsningen og kartdataene -->
		var about = creator.createDiv({id: "help-topic-about", css: "help-topic"});
		var aboutButton = creator.createButton({css: "btn btn-topmenu btn-noborder", ariaLabel: "vis/skjul informasjon om løsningen og kartdataene", text: "Løsningen og kartdataene"});
		aboutButton.onclick = function() {
			if($("#aboutArticle").is(":visible")) {
				$("#aboutArticle").hide(250);
				$("#help-topic-about").find("i").addClass("icon-Chevron-down").removeClass("icon-Chevron-upFill");
			}else{
				$(".help-topic").find("article").hide(250);
				$(".help-topic").find("i").removeClass("icon-Chevron-upFill").addClass("icon-Chevron-down");
				$("#aboutArticle").show(200);
				$("#help-topic-about").find("i").removeClass("icon-Chevron-down").addClass("icon-Chevron-upFill");
			}
		};
		aboutButton.appendChild(creator.createIcon({css: "icon-Chevron-down tipsmenu-expander"}));
		about.appendChild(aboutButton);
		
		var aboutArticle = creator.createArticle({id: "aboutArticle"});
		aboutArticle.appendChild(creator.createH4({text: "Om løsningen"}));
		aboutArticle.appendChild(creator.createParagraph({text: "Løsningen utvikles og driftes av Plan- og bygningsetaten. Følgende rammeverk er benyttet for løsningen:"}));
		aboutArticle.appendChild(creator.createUl({listItems: ["JQuery-3.3.1", "OpenLayers-4.3.1", "Proj4JS", "RequireJS-2.1.16", "JQuery-Ui-1.12.0", "Jquery-Ui-datepicker-nb", "Jquery.mobile-1.4.5","Jquery.autocomplete-1.2.26","Font Awesome-4.6.1","popper-1.12.2","Bootstrap-4.3.1","Bootstrap.css-3.3.6"]}));
		aboutArticle.appendChild(creator.createParagraph({text: "Det kan forekomme feil i symbolisering av reguleringskartet. Feilene vil bli rettet så fort vi blir oppmerksomme på dem."}));
		aboutArticle.appendChild(creator.createParagraph({text: 'Ønsker du å gi tilbakemeldinger finner du en lenke nederst i denne menyen.'}));
		aboutArticle.appendChild(creator.createH4({text: "Om kartdataene"}));
		aboutArticle.appendChild(creator.createParagraph({text: "<span>Planer:</span> De øverste kartlagene i menyen til venstre er plankart. Kommuneplan, Kommunedelplaner og Reguleringsplaner kan ekspanderes ved hjelp av pilen til høyre for å filtrere ut det du ikke ønsker å se på. Områderegulering og Reguleringsplaner oppdateres hver natt. De andre oppdateres når det skjer endringer."}));
		aboutArticle.appendChild(creator.createParagraph({text: '<span>Pågående saker: </span>Disse kartlagene viser ulike planer som ikke er vedtatt og byggesaker som er pågående.'}));
		aboutArticle.appendChild(creator.createParagraph({text: '<span>Temakart:</span> Under temakart finner du kart som er laget for å belyse et bestemt tema innenfor et gitt geografisk område. Det tematiske kartet viser som regel bare informasjon om ett eller et fåtall emner. Du finner tegnforklaring og informasjon om hvert kartlag ved å klikke på «Mer info» i menyen.'}));
		aboutArticle.appendChild(creator.createParagraph({text: '<span>Historiske flyfoto:</span> Du finner flyfoto fra 1937, 1947, 1971, 1984 og 1997. Velg «ingen» for å slå av historiske flyfoto.'}));
		aboutArticle.appendChild(creator.createParagraph({text: '<span>Detaljer:</span>'}));
		aboutArticle.appendChild(creator.createUl({listItems: ['Kartlaget «Bygninger, veier, koter m.m.» kalles ofte grunnkart og viser situasjonen slik den er i dag. Kartet er konstruert hovedsakelig fra flyfoto som tas om våren hvert år. Dette kartet oppdateres en gang i uken.','«Gatenavn, adresser m.m.» viser stedsnavn, gatenavn, adressenummer med mer. Kartlaget oppdateres en gang i uken.','«Eiendomsgrenser» viser eiendomsgrenser, seksjonsgrenser og gårds- og bruksnummer. Gårds- og bruksnummer vises bare når du har zoomet inn på en eiendom. Eiendomskartet oppdateres hver natt.','«Bydelsgrenser» viser bydelsgrenser og bydelsnavn. Oppdateres ved behov.']}));
		aboutArticle.appendChild(creator.createParagraph({text: "<span>Flyfoto/Bakgrunnskart: </span>Flyfoto blir fornyet hvert år. Bakgrunnskart er et forenklet situasjonskart som i hovedsak viser bygninger, veier og vann."}));
		aboutArticle.appendChild(creator.createH4({text: "<strong>Kjøp av kartdata</strong>"}));
		aboutArticle.appendChild(creator.createParagraph({text: " Kartdata kan kjøpes via Bestillingstjenesten, Infoland eller vårt Kundesenter. Når du klikker i kartet slik at du før opp informasjonsmenyen til høyre har du mulighet til å bruke hurtiglenker for å bestille byggesakspakke eller eiendomsmeglerpakke. Hurtiglenken tar med seg gårds- og bruksnummeret til eiendommen du klikket på."}));
		
		about.appendChild(aboutArticle);
		
		content.appendChild(about);
		
		//<!--Slett nettleserdata-->
		var storage = creator.createDiv({css: "help-topic"});
		var storageButton = creator.createButton({css: "close-me hide-me", ariaLabel: "vis informasjon om vilkår for bruk av tjenesten", text: "Tilbakestill instillinger"});
		storageButton.onclick = function(){
			$.each(localStorage, function (obj) {
				if (obj.indexOf("planinnsyn") >= 0) {
					localStorage.removeItem(obj);
				}
				$("#hideSketchTip").attr("checked", false);
				$("#hideMeasureTip").attr("checked", false);
			});
			$("#hide-sketch-tip").prop("checked", false);
			$("#hide-measure-tip").prop("checked", false);
			alert("Lokale innstillinger for Planinnsyn har blitt slettet.");
		};
		storage.appendChild(storageButton);
		content.appendChild(storage);
		
		//<!--Gi tilbakemelding-->
		var tilbakemelding = creator.createDiv({css: "Help-topic"});
		var tilbakemeldingBtn = creator.createButton({ariaLabel: "Gi oss tilbakemelding", css: "user-message-intranett", text: "<a>Gi oss tilbakemelding </a>"});
		tilbakemeldingBtn.appendChild(creator.createIcon({css: "glyphicon glyphicon-comment"}));
		tilbakemeldingBtn.onclick = function () {
			var url = "mailto:liva.vagane@pbe.oslo.kommune.no&subject=Tilbakemelding%20Planinnsyn&body=Skriv%20tilbakemeldingen%20din%20her";
			window.location.href = url;
		};
		tilbakemelding.appendChild(tilbakemeldingBtn);

		var tilbakemeldingBtnInternett = creator.createButton({ariaLabel: "Gi oss tilbakemelding", text: "<a>Gi oss tilbakemelding </a>", css: "user-message-internett"});
		tilbakemeldingBtnInternett.appendChild(creator.createIcon({css: "icon-new-window"}));
		tilbakemeldingBtnInternett.onclick = function () {
			window.open("https://innsyn.pbe.oslo.kommune.no/saksinnsyn/getfeedback.asp?side=kartside", "_blank");
			//e.stopPropagation();
		};
		tilbakemelding.appendChild(tilbakemeldingBtnInternett);
		
		content.appendChild(tilbakemelding);
		
		
		el.appendChild(content);
		return el;
	},
	addTopMenuItems: function(topMenuItems, intranett){
		var target = $(".drop-down-link-menu");
		topMenuItems.forEach(function (item) {
			target.prepend(privateFns.addTopMenuItem(item));
		});
		var smallScreenButton = creator.createButton({css: "top-menu-button small-screen", ariaLabel: "Se flere valg"});
		smallScreenButton.style.color = "#2A2859";
		smallScreenButton.appendChild(creator.createIcon({css: "glyphicon glyphicon-option-vertical"}));
		smallScreenButton.onclick = function(){
			var target = $(".drop-down-link-menu");
			$(".drop-downs").hide();
			if ($(window).width() < 767) {
				$("#searchinput").hide();
			}
			target.toggleClass("show-collapsible");
		};
		$("#middleDiv").prepend(smallScreenButton);
	},
	addTopMenuItem: function (item, intranett) {
		var itemElement = creator.createButton({});
		if (item.type === "button") {
			itemElement.type = "button";
			itemElement.id = item.id;
			itemElement.className = "drop-down-row";
			itemElement.title = item.toolTip;
			itemElement.innerHTML = "";
			itemElement.innerHTML += item.innerHTML;
			if (item.icon) {
				itemElement.innerHTML += "<i class='" + item.iconClass + "'></i>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if (item.svg) {
				itemElement.innerHTML += "<img src='" + item.iconClass + "'></img>";
				if (item.iconHTML) {
					itemElement.innerHTML += "<span class='icon-text'>" + item.iconHTML + "</span>";
				}
				itemElement.innerHTML += " ";
			}
			if(typeof item.onclick === "function") {
				itemElement.onclick = item.onclick;
			}else {
				itemElement.onclick = clickFns[item.onclick];
			}
			if(item.contentPage){
				$("#map").append(privateFns[item.contentPage]());
			}
		}
		return itemElement;
	},
	createWKTStringFromFeatures: function () {
		var wktString = "";
			for (const [key, plug] of Object.entries(global.registeredPlugins)) {
				var shareString = "", paramName;
				if(plug.share){
					shareString += plug.share();
					paramName = plug.id;
				}
				if (shareString && shareString.length > 0) {
					shareString = "&" + paramName + "=" + encodeURIComponent(shareString);
				}
				wktString += shareString;
			}
		return wktString;
	},
	updateUrl: function () {
		//var urlBase = {partList: {}, addPart: {}};
		let siteUrl = "http://" + location.hostname + location.pathname;
		for (var key in urlBase.addPart){
			if(urlBase.addPart[key]){
				siteUrl += urlBase.partList[key];
			}
		}
		let wktString = privateFns.createWKTStringFromFeatures();
		if(wktString && wktString.length > 0){				
			siteUrl += wktString;
		}
		
		var permalink = creator.createA({css: "permalink"});
		permalink.innerHTML = siteUrl;
		permalink.href = siteUrl;
		
		$(".share-url").html(permalink);
		
	},
	togglePermalinkSharingBtns: function (siteUrl) {
		if (siteUrl.length >= 2000) {
			siteUrl = "Url-en er for lang på grunn av for mange tegninger, målinger eller kommentarer";
			$(".user-message-intranett").hide();
			$("#copy-link").hide();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		} else if (siteUrl.length >= 1840) {
			$("#copy-link").show();
			$("#share-email").hide();
			$("#share-twitter").hide();
			$("#share-facebook").hide();
			if (intranett) {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost. Du kan fortsatt kopiere url-en manuelt og dele den.");
			} else {
				$("#share-page").find("span").html("Url-en er for lang til deling via epost, twitter og facebook. Du kan fortsatt kopiere url-en manuelt og dele den.");
			}
		} else if (siteUrl.length > 140) {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").hide();
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		} else {
			$("#copy-link").show();
			$("#share-email").show().attr("href", "mailto:?subject=planinnsyn.oslo.no&body=" + encodeURIComponent(siteUrl) + "%0D%0A%0D%0APlan- og bygningsetaten");
			$("#share-twitter").show().attr("href", "http://twitter.com/share?url=" + encodeURIComponent(siteUrl));
			$("#share-facebook").show().attr("href", "http://facebook.com/sharer.php?u=" + encodeURIComponent(siteUrl));
			$("#share-page").find("span").html("Del via:");
		}

		if (intranett) {
			$("#share-twitter").hide();
			$("#share-facebook").hide();
		}
		return siteUrl;
	},
};

clickFns = {
	shareClick: function(){
		$("#share-page").toggle(250);
		$("#help-page").hide(250);
		var permalink = creator.createA({css: "permalink"});
		var lyrArray = [];
		global.forAllLayers(global.map, function (l) {
			if (l.getVisible() && l.get("group") !== "hidden" && l.get("displayInLayerMenu") && !l.get("layers") && $("#"+l.values_.layerId)[0]) {
				lyrArray.push(l.values_.layerId);
			}
		});
		urlBase.partList.list = global.list ? "?list=" + global.list : "?";
		urlBase.addPart.list = true;
		
		urlBase.partList.mode = "&mode=" + lyrArray.join(",");
		urlBase.addPart.mode = true;
		
		urlBase.partList.point = "&north=" + global.map.getView().getCenter()[1]  + "&east=" + global.map.getView().getCenter()[0];
		urlBase.addPart.point = true;
		
		urlBase.partList.pointMark = "&lat=" + global.map.getView().getCenter()[1]  + "&lon=" + global.map.getView().getCenter()[0];
		urlBase.addPart.pointMark = false;
		
		privateFns.updateUrl();
	},
};

export default {
	initiate: function(items, intranett){
		intranett = intranett; 
		privateFns.addTopMenuItems(items);
		if (intranett) {
			$(".user-message-intranett").show();
		} else {
			$(".user-message-internett").show();
		}
	},
};

